"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/******************************************** LOGGING *********************************************/
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory('delegation.ts', shared_1.Styles.bracelet);
/**
 * Instantiate & bind value to a lateinit prop
 */
exports.instantiateAndBindToLateinit = function (Klass) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    // You will need 2 attempts to bind it, due to the lateinit prop
    var instance;
    // 1st attempt to bind in the catch block
    try {
        instance = new (Klass.bind.apply(Klass, [void 0].concat(args)))();
        // 2nd attempt to bind in the catch block
    }
    catch (error) {
        if (Klass.name) {
            log.info("bindToLateInit :: 1st attempt to build " + Klass.name + " failed - error:", error);
        }
        else {
            log.info("bindToLateInit :: 1st attempt to build ", Klass, " failed - error:", error);
        }
        instance = new (Klass.bind.apply(Klass, [void 0].concat(args)))();
    }
    // Final return. Ensure it's not undefined.
    return instance || null;
};
//# sourceMappingURL=delegation.js.map